import styled from "@emotion/styled";
export const StyledLongFooterComponent = styled.div``;
